import { version } from "./package.json";

// чтобы разделять сурсмапы одной версии для разных проектов
export const release = `${version}-clientapp`;
